import request from '@/utils/request'
export const getVisitorCount = () => {
  return request.get('/systemInfos/visitor')
}
